/** Pixel-space contours; resizing must not stretch the taper's line widths. */
export function saltTrackGeometry(width: number, height: number, cornerRadius = height / 2) {
	const w = Number.isFinite(width) && width > 0 ? width : 1000;
	const h = Number.isFinite(height) && height > 0 ? height : 80;
	const r = Math.max(3, Math.min(Number.isFinite(cornerRadius) ? cornerRadius : h / 2, w / 2, h / 2));
	const mid = h / 2;
	const k = r * (1 - 0.55228475);
	const right = w - r;
	return {
		width: w, height: h, radius: r,
		taper: `M.5 ${mid} V${r} C.5 ${k} ${k} .6 ${r} .6 H${right} C${w - k} .6 ${w - .5} ${k} ${w - .5} ${r} V${mid} L${w - .8} ${mid} V${r} C${w - .8} ${k} ${w - k} 2.2 ${right} 2.2 H${r} C${k} 2.2 .8 ${k} .8 ${r} V${mid} Z`,
		progress: `M.65 ${mid} V${r} C.65 ${k} ${k} 1.4 ${r} 1.4 H${right} C${w - k} 1.4 ${w - .65} ${k} ${w - .65} ${r} V${mid}`,
		outline: `M${r} .7 H${right} C${w - k} .7 ${w - .7} ${k} ${w - .7} ${r} V${h - r} C${w - .7} ${h - k} ${w - k} ${h - .7} ${right} ${h - .7} H${r} C${k} ${h - .7} .7 ${h - k} .7 ${h - r} V${r} C.7 ${k} ${k} .7 ${r} .7 Z`,
	};
}
